import Vue from "vue";
import VueRouter from "vue-router";

// 系统首页
const Index = () => import("@/views/Index.vue");

// 登录/注册
const Login = () => import("@/views/Login.vue");

//  过滤重复路径抛出异常
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

// 错误
const error = [
  // 404页面
  {
    path: "/404",
    name: "notfound",
    meta: { title: "404" },
    component: () => import("../views/404.vue"),
  },
  // 500页面
  {
    path: "/500",
    name: "error",
    meta: { title: "500" },
    component: () => import("../views/500.vue"),
  },
];

// 登录/注册
const login = [
  {
    path: "/login",
    name: "login",
    meta: { title: "登录", authority: false },
    component: Login,
  },
];

// 点单
const good = [
  {
    path: "good",
    name: "Good",
    meta: { title: "商品", authority: true },
  },
  {
    path: "good/classify",
    name: "GoodClassifyList",
    meta: { title: "分类管理", authority: true },
    component: () => import("@/views/good/Classify.vue"),
  },
  {
    path: "good/goods",
    name: "GoodsMenuList",
    meta: { title: "商品管理", authority: true },
    component: () => import("@/views/good/Goods.vue"),
  },
  {
    path: "good/Goods/Add",
    name: "GoodAdd",
    meta: { title: "添加商品", authority: true },
    component: () => import("@/views/good/Add.vue"),
  },
  {
    path: "good/supply",
    name: "SupplyList",
    meta: { title: "商品分类管理", authority: true },
    component: () => import("@/views/good/SupplyList.vue"),
  },
  {
    path: "good/banjiaGood",
    name: "banjiaGood",
    meta: { title: "半价/特价秒杀", authority: true },
    component: () => import("@/views/good/BanjiamiaoshaGood.vue"),
  },
  {
    path: "good/miandanGood",
    name: "miandanGood",
    meta: { title: "会员免单", authority: true },
    component: () => import("@/views/good/huiyuanmiandan.vue"),
  },
  {
    path: "good/giftPackage",
    name: "GiftPackage",
    meta: { title: "礼包管理", authority: true },
    component: () => import("@/views/good/GiftPackage.vue"),
  },{
    path: "good/bawangcan",
    name: "Bawangcan",
    meta: { title: "霸王餐配置", authority: true },
    component: () => import("@/views/config/bawangcan.vue"),
  },
];

// 订单
const order = [
  {
    path: "order",
    name: "Order",
    meta: { title: "订单", authority: true },
  },
  {
    path: "order/list",
    name: "OrderList",
    meta: { title: "订单管理", authority: true },
    component: () => import("@/views/order/List.vue"),
  },
  {
    path: "order/gyllist",
    name: "OrderGylList",
    meta: { title: "供应链订单", authority: true },
    component: () => import("@/views/order/gylList.vue"),
  },
  {
    path: "order/pintuanOrder",
    name: "pintuanOrder",
    meta: { title: "拼团订单", authority: true },
    component: () => import("@/views/order/pintuanOrder.vue"),
  },
  {
    path: "order/goods-stat",
    name: "OrderGoodsStat",
    meta: { title: "商品统计", authority: true },
    component: () => import("@/views/order/GoodsStatistics.vue"),
  },
  {
    path: "order/redeemList",
    name: "RedeemList",
    meta: { title: "分享0元吃面统计", authority: true },
    component: () => import("@/views/order/redeemList.vue"),
  },
  {
    path: "order/memberGiftRedeem",
    name: "MemberGiftRedeem",
    meta: { title: "会员礼包核销订单", authority: true },
    component: () => import("@/views/order/memberGiftRedeem.vue"),
  },
  {
    path: "order/shareCouponManage",
    name: "ShareCouponManage",
    meta: { title: "分享福利券管理", authority: true },
    component: () => import("@/views/order/shareCouponManage.vue"),
  },
    {
    path: "order/couponUseDetail",
    name: "couponUseDetail",
    meta: { title: "用户核销详情", authority: true },
    component: () => import("@/views/order/couponUseDetail.vue"),
  },    {
    path: "order/flCoupon",
    name: "flCoupon",
    meta: { title: "福利核销券", authority: true },
    component: () => import("@/views/order/flCoupon.vue"),
  },    {
    path: "order/bwcCoupon",
    name: "bwcCoupon",
    meta: { title: "霸王餐核销券", authority: true },
    component: () => import("@/views/order/bwcCoupon.vue"),
  },   {
    path: "order/fuliUsedCoupon",
    name: "flUsedCoupon",
    meta: { title: "福利核销券", authority: true },
    component: () => import("@/views/order/flUsedCoupon.vue"),
  },    {
    path: "order/bwcUsedCoupons",

    name: "bwcUsedCoupons",
    meta: { title: "霸王餐核销券", authority: true },
    component: () => import("@/views/order/bwcUsedCoupon.vue"),
  },
];

// 会员
const member = [
  {
    path: "member",
    name: "member",
    meta: { title: "会员", authority: true },
  },
  {
    path: "member/list",
    name: "memberList",
    meta: { title: "会员列表", authority: true },
    component: () => import("@/views/member/List.vue"),
  },
  {
    path: "member/dllist",
    name: "MemberDailiList",
    meta: { title: "代理列表", authority: true },
    component: () => import("@/views/member/dllist.vue"),
  },
  {
    path: "member/list/distribution",
    name: "memberDistribution",
    meta: { title: "分销详情", authority: true },
    component: () => import("@/views/member/Distribution.vue"),
  },
  {
    path: "member/distributionRecords",
    name: "memberDistributionRecords",
    meta: { title: "分销明细", authority: true },
    component: () => import("@/views/member/DistributionRecords.vue"),
  },
  {
    path: "member/withdrawal",
    name: "memberWithdrawal",
    meta: { title: "提现审核", authority: true },
    component: () => import("@/views/member/Withdrawal.vue"),
  },
  {
    path: "member/withdrawalList",
    name: "memberWithdrawalList",
    meta: { title: "提现列表", authority: true },
    component: () => import("@/views/member/WithdrawalList.vue"),
  },
  {
    path: "member/subscription",
    name: "memberSubscription",
    meta: { title: "认缴人员", authority: true },
    component: () => import("@/views/member/Subscription.vue"),
  },
  {
    path: "member/financialrecords",
    name: "memberFinancialRecords",
    meta: { title: "财务记录", authority: true },
    component: () => import("@/views/member/FinancialRecords.vue"),
  },
];

// 门店
const store = [
  {
    path: "store",
    name: "store",
    meta: { title: "门店", authority: true },
  },
  {
    path: "store/list",
    name: "storeList",
    meta: { title: "门店列表", authority: true },
    component: () => import("@/views/store/List.vue"),
  },
  {
    path: "store/list/table",
    name: "storeTable",
    meta: { title: "门店桌子", authority: true },
    component: () => import("@/views/store/Table.vue"),
  },
  {
    path: "store/devlist",
    name: "StoreDev",
    meta: { title: "开发门店", authority: true },
    component: () => import("@/views/store/Devlist.vue"),
  },
];

// 配置
const config = [
  {
    path: "config",
    name: "config",
    meta: { title: "配置", authority: true },
  },
  {
    path: "config/achievement",
    name: "ConfigAchievement",
    meta: { title: "业绩收益分佣配置", authority: true },
    component: () => import("@/views/config/achievement.vue"),
  },  {
    path: "config/bawangcan",
    name: "Bawangcan",
    meta: { title: "霸王餐配置", authority: true },
    component: () => import("@/views/config/bawangcan.vue"),
  },
];

// 运营
const operate = [
  {
    path: "operate",
    name: "operate",
    meta: { title: "运营", authority: true },
  },
  {
    path: "operate/banner",
    name: "OperateBanner",
    meta: { title: "轮播管理", authority: true },
    component: () => import("@/views/operate/banner.vue"),
  },
  {
    path: "operate/qrcode",
    name: "qrcodeBackground",
    meta: { title: "二维码背景", authority: true },
    component: () => import("@/views/qrcode/banner.vue"),
  },
  {
    path: "operate/server",
    name: "server",
    meta: { title: "客服电话", authority: true },
    component: () => import("@/views/operate/server.vue"),
  },
  {
    path: "operate/announcement",
    name: "announcement",
    meta: { title: "发布公告", authority: true },
    component: () => import("@/views/operate/announcement.vue"),
  },
  {
    path: "operate/coupon",
    name: "coupon",
    meta: { title: "满减优惠券", authority: true },
    component: () => import("@/views/operate/coupon.vue"),
  },
  {
    path: "operate/advertisement",
    name: "advertisement",
    meta: { title: "首页广告", authority: true },
    component: () => import("@/views/operate/advertisement.vue"),
  },
];

// 统计
const statistics = [
  {
    path: "statistics",
    name: "statistics",
    meta: { title: "统计", authority: true },
  },
  {
    path: "statistics/datalist",
    name: "statisticsDatalist",
    meta: { title: "门店数据", authority: true },
    component: () => import("@/views/statistics/datalist.vue"),
  },
  {
    path: "statistics/supply",
    name: "statisticsSupply",
    meta: { title: "供应链数据", authority: true },
    component: () => import("@/views/statistics/supply.vue"),
  },
  {
    path: "statistics/transaction",
    name: "statisticsTransaction",
    meta: { title: "交易统计", authority: true },
    component: () => import("@/views/statistics/Transaction.vue"),
  },
  {
    path: "statistics/transaction/income",
    name: "statisticsIncome",
    meta: { title: "收入概况", authority: true },
    component: () => import("@/views/statistics/Income.vue"),
  },
  {
    path: "statistics/transaction/expend",
    name: "statisticsExpend",
    meta: { title: "支出概况", authority: true },
    component: () => import("@/views/statistics/Expend.vue"),
  },
  {
    path: "statistics/transaction/commission",
    name: "statisticsCommission",
    meta: { title: "佣金概况", authority: true },
    component: () => import("@/views/statistics/Commission.vue"),
  },
  {
    path: "statistics/transaction/unissued",
    name: "statisticsUnissued",
    meta: { title: "未发放佣金概况", authority: true },
    component: () => import("@/views/statistics/Unissued.vue"),
  },
  {
    path: "statistics/sales",
    name: "statisticsSales",
    meta: { title: "销量统计", authority: true },
    component: () => import("@/views/statistics/Sales.vue"),
  },
  {
    path: "statistics/MemberList",
    name: "statisticsMemberList",
    meta: { title: "会员单数据", authority: true },
    component: () => import("@/views/statistics/MemberList.vue"),
  },
];

// 设置页面
const set = [
  {
    path: "set",
    name: "set",
    meta: { title: "设置", authority: true },
  },
  {
    path: "set/shelf",
    name: "setShelf",
    meta: { title: "上架管理", authority: true },
    component: () => import("@/views/set/Shelf.vue"),
  },
  {
    path: "set/role",
    name: "setRole",
    meta: { title: "角色管理", authority: true },
    component: () => import("@/views/set/Role.vue"),
  },
  {
    path: "set/user",
    name: "setUser",
    meta: { title: "用户管理", authority: true },
    component: () => import("@/views/set/User.vue"),
  },
  {
    path: "set/menu",
    name: "setMenu",
    meta: { title: "菜单管理", authority: true },
    component: () => import("@/views/set/Menu.vue"),
  },
];

// 其他页面
const other = [
  {
    path: "other",
    name: "other",
    meta: { title: "其他板块", authority: true },
  },
  {
    path: "other/password",
    name: "password",
    meta: { title: "修改密码", authority: true },
    component: () => import("@/views/other/Password.vue"),
    // component: Password,
  },
  {
    path: "other/personal",
    name: "personal",
    meta: { title: "个人中心", authority: true },
    component: () => import("@/views/other/Personal.vue"),
  },
];

// 分账
const bill = [
  {
    path: "bill",
    name: "bill",
    meta: { title: "分账", authority: true },
    component: () => import("@/views/bill/List.vue"),
  },
  {
    path: "bill/storeBill",
    name: "storeBill",
    meta: { title: "门店分账", authority: true },
    component: () => import("@/views/bill/StoreBill.vue"),
  },
];

const routes = [
  {
    path: "/",
    redirect: { name: "home" },
  },
  // 框架页面
  {
    path: "/admin",
    name: "home",
    redirect: { name: "index" },
    component: () => import("../views/Home.vue"),
    children: [
      // 系统首页
      {
        path: "index",
        name: "index",
        meta: { title: "首页", authority: true, crumbs: true },
        component: Index,
      },
      ...set,
      ...member,
      ...store,
      ...good,
      ...order,
      ...other,
      ...config,
      ...operate,
      ...statistics,
      ...bill,
    ],
  },
  // 登录/注册
  ...login,
  // 错误页面
  ...error,
  // 重定向
  {
    path: "*",
    redirect: { name: "notfound" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function isShareVisit(to) {
  const path = (to.path || "").toLowerCase();
  const query = to.query || {};
  const from = String(query.from || "").toLowerCase();
  const share = String(query.share || query.isShare || "").toLowerCase();
  const inSharePath = path.includes("/share");
  const byQuery = from === "share" || share === "1" || share === "true";
  return Boolean(to.meta && to.meta.sharePublic) || inSharePath || byQuery;
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 页面SEO设置
  to.meta.title && (document.title = to.meta.title);
  to.meta.keywords &&
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", to.meta.keywords);
  to.meta.description &&
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", to.meta.description);

  if (isShareVisit(to)) {
    next();
    return;
  }

  // 判断页面是否需要授权
  if (to.meta.authority) {
    // 判断是否登录
    if (localStorage.getItem("USER_TOKEN")) {
      // 有权限
      next();
    } else {
      // 无权限
      next({ name: "login" });
    }
  } else {
    // 无需验证的页面
    next();
  }
});

// 全局后置钩子
router.afterEach((to, from) => {});

Vue.use(VueRouter);

export default router;
